import identity from 'transmute/identity';
import { fetchConditionalPropertyRules } from '../../v2/conditionalPropertyRules/api';
import { InMemoryCache } from '../InMemoryCache';
export const makeConditionalPropertyRulesCache = () => new InMemoryCache('ConditionalPropertyRulesCache', fetchConditionalPropertyRules, identity);